import { Link } from "react-router";
import IconDone from "../icons/IconDone";
import LinkArrow from "../icons/LinkArrow";

export const EntryCard = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="card-body d-flex gap-2 gap-lg-5 align-items-start flex-column flex-lg-row align-items-lg-center">
      {children}
    </div>
  );
};

export const EntryCardHeading = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <h2
      className="display-3 fw-semibold text-dark"
      style={{ minWidth: "20rem" }}
    >
      {children}
    </h2>
  );
};

export const EntryCardDoneText = (props: { children: React.ReactNode }) => {
  const { children } = props;
  return (
    <p className="fw-normal small d-flex gap-1 align-items-center m-0 text-dark">
      <IconDone className="text-success" /> {children}
    </p>
  );
};

export const EntryCardOpenText = (props: { children: React.ReactNode }) => {
  const { children } = props;
  return (
    <p className="fw-normal small d-flex gap-1 align-items-center m-0 text-dark">
      {children}
    </p>
  );
};

export const EntryCardLinkText = (props: { children: React.ReactNode }) => {
  const { children } = props;
  return (
    <span className="d-flex gap-3 align-items-center text-primary fw-semibold fs-6 ms-lg-auto mt-3 mt-lg-0">
      {children} <LinkArrow />
    </span>
  );
};

export function LinkCard(props: {
  title: string;
  description: JSX.Element | string;
  linkTo: string;
  linkText: string;
}) {
  return (
    <Link to={props.linkTo} className="card">
      <EntryCard>
        <EntryCardHeading>{props.title}</EntryCardHeading>
        <EntryCardOpenText>{props.description}</EntryCardOpenText>
        <EntryCardLinkText>{props.linkText}</EntryCardLinkText>
      </EntryCard>
    </Link>
  );
}
